// constsPlugin.js
import orgRights from '@/libs/constant/orgRights'
  
let YourConsts = {}; // As suggested by the comments.

YourConsts.install = function (Vue) {
    Vue.prototype.$getConst = (key) => {
        return orgRights[key]
    }
}

export default YourConsts
  